module.exports = __webpack_public_path__ + "static/img/dash-stat-duration.216f3a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dash-stat-duration.png
// module id = OLWn
// module chunks = 1